export enum DisputStatus {
  Underfined = 0,
  Created = 1,
  InProgress = 2,
  Satisfied = 3,
  Rejected = 4,
  Returned = 5,
  Reopened = 6,
}

export type DisputListModel = {
  id: string
  createdAt: string
  userId: string
  paymentId: string
  merchantId: string
  traderId: string
  adminId: string | null
  status: DisputStatus
  receiptFile: string | null
  receiptType: string | null
  receiptUrl: string | null
  paymentTextRequisit: string | null
  bankName: string | null
  cardNumber: string | null
  deviceName: string | null
  deviceId: string | null
  amount: number | null
  description: string | null
  disputAmountFromMerchant: number
  disputAmountFromMerchantUsdt: number
  disputAmountFromTrader: number
  disputAmountFromTraderUsdt: number | null
}

export type DisputModel = {
  id: string
  createdAt: string
  userId: string
  paymentId: string
  merchantId: string
  traderId: string
  adminId: string | null
  status: DisputStatus
  receiptFile: string | null
  receiptType: string | null
  receiptUrl: string | null
  description: string | null
  disputAmountFromMerchant: number
  disputAmountFromMerchantUsdt: number
  disputAmountFromTrader: number | null
  disputAmountFromTraderUsdt: number | null
}

export type NewStatusDisputModel = {
  id: string
  status: number
  description?: string
  disputAmountFromTrader?: number
}

export type NewDisputModel = {
  paymentId: string
  receiptFile: string
  disputAmountFromMerchant: number
  receiptType: string
  receiptUrl: string
  description: string
}

export const DefaultDisputListModel: DisputListModel = {
  id: '',
  createdAt: '',
  userId: '',
  paymentId: '',
  merchantId: '',
  traderId: '',
  adminId: '',
  status: 1,
  receiptFile: '',
  receiptType: '',
  receiptUrl: '',
  description: '',
  paymentTextRequisit: '',
  bankName: '',
  cardNumber: '',
  deviceName: '',
  deviceId: '',
  amount: 0,
  disputAmountFromMerchant: 0,
  disputAmountFromMerchantUsdt: 0,
  disputAmountFromTrader: 0,
  disputAmountFromTraderUsdt: 0,
}

export const DefaultDisputModel: DisputModel = {
  id: '',
  createdAt: '',
  userId: '',
  paymentId: '',
  merchantId: '',
  traderId: '',
  adminId: '',
  status: 1,
  receiptFile: '',
  receiptType: '',
  receiptUrl: '',
  description: '',
  disputAmountFromMerchant: 0,
  disputAmountFromMerchantUsdt: 0,
  disputAmountFromTrader: 0,
  disputAmountFromTraderUsdt: 0,
}
